let axios = `
import axios from "axios";

const options = {
    method: '',
    url: '',
    headers: {},
    data: {}
};

axios.request(options).then(function (response) {
    console.log(response.data);
}).catch(function (error) {
    console.error(error);
});
`

export default (options) => {
    return axios.replace(/{.*};/s, JSON.stringify(options, null, 4))
}
